import { Stack } from '@chakra-ui/react'
import React from 'react'
import { InputRowGrid } from '../../shared/InputRowGrid'
import RadioCardGroup from '../RadioCardBox'
import {HiUserGroup} from "react-icons/hi";
import {AiOutlineLock,AiOutlineUser} from "react-icons/ai";
import {FiUsers} from "react-icons/fi";

export default function JobVisibility() {
  return (
    
    <Stack gap={5}>
      <InputRowGrid
        heading="Who see your Job"
        input={<RadioCardGroup options={jobOptions} />}
      />
      <InputRowGrid
        heading="People do you need for this Job"
        input={<RadioCardGroup options={peopleOptions} />}
      />
    </Stack>
  )
}
const jobOptions = [
  {
    heading:"Anyone",
    text:"Freelancers using Decolance and public search engines can find this job.",
    icon:<HiUserGroup />,

  },
  {
    heading:"Only Decolance Talent",
    text:"Only Decolance users can find this job",
    icon:<svg id="Group_1125" data-name="Group 1125" xmlns="http://www.w3.org/2000/svg" width="28.106" height="28.106" viewBox="0 0 28.106 28.106">
    <path id="Path_1" data-name="Path 1" d="M290.77,213.047A14.053,14.053,0,1,0,304.823,227.1,14.069,14.069,0,0,0,290.77,213.047Zm2.949,26.854q-.625.144-1.271.227c4.664-7.138-10.807-17.1-13.5-18.754a13.151,13.151,0,0,1,1.1-1.856c1.7,1.756,3.769,1.989,11.291,9.3C297.508,234.8,295.13,238.515,293.719,239.9Zm-16.065-12.062c1.98,1.039,9.621,5.225,10.718,8.516.637,1.91-.84,2.818-1.795,3.194A13.164,13.164,0,0,1,277.653,227.839Zm17.766,11.548c13.235-7.373-7.657-21.607-11-23.784a13.136,13.136,0,1,1,11,23.784Z" transform="translate(-276.717 -213.047)" fill="#888"/>
  </svg>
  
  },
  {
    heading:"Invite-Only",
    text:"Only Freelancers you have invited can find this job.",
    icon:<AiOutlineLock />,
  }
];
const peopleOptions = [
  {
    heading:"One freelancer",
    icon:<AiOutlineUser />
  },
  {
    heading:"More than one freelancer",
    icon:<FiUsers />
  },

]